module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-160x160-2ea0261fa74332dfba18a0c4bfa73f31.png";